import React, { useEffect } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Link, useLocation } from 'react-router-dom'

const PortFolioDetail = () => {
    const { state } = useLocation();
    const { project } = state;
    const projectVideo = project?.media?.find((thm) => thm?.collection_name === "project_videos" ? thm : '');
    useEffect(() => {
        window.scroll(0, 0);
    }, []);
    return (
        <div className='portfolioDetail'>
            <Container>
                <Row className='d-flex justify-content-between'>
                    <Col xs={12} sm={12} md={12} lg={4} xl={5} xxl={5}>
                        <div className='headingTextArea'>
                            <Link to='/portfolio'>Back To Work</Link>
                            <h2>{project?.project_title} </h2>
                            <h6>{project?.project_type}</h6>
                            <div dangerouslySetInnerHTML={{ __html: project?.summary?.slice(0, 100) }}
                            ></div>
                        </div>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={7} xl={7} xxl={7}>
                        <div className="hero-video">
                            <video muted autoPlay controls loop playsInline src={project?.video_url != '' ? project?.video_url : projectVideo?.original_url} type="video/mp4"
                                className="w-100 h-70">
                            </video>
                        </div>
                    </Col>
                </Row>
            </Container>
            <div className='portfolioDetailChallenges'>
                <Container>
                    <Row className='d-flex justify-content-between'>
                        <Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-5'>
                            <div className='portfolioDetailChallengesText'>
                                <h3>The Challenges</h3>
                                <div
                                    dangerouslySetInnerHTML={{ __html: project?.challenge }}
                                />
                            </div>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>
                            <div className='portfolioDetailChallengesText'>
                                <h3> The Solutions</h3>
                                <div
                                    dangerouslySetInnerHTML={{ __html: project?.solution }}
                                />
                            </div>
                        </Col>

                    </Row>
                </Container>
            </div>

            <div className='portfolioDetailBehindTheSeen'>
                <Container>
                    <h2 className='titleSection text-center mb-5'>Behind The Scene</h2>
                    <Row className='d-flex justify-content-center'>
                        {state?.project?.media?.map((med, s) => {
                            if (med?.collection_name == "behind_seen") {
                                return (
                                    <Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} key={s}>
                                        <div className='portfolioSlideItemImage' style={{ background: `url(${med?.original_url})` }}>
                                        </div>
                                    </Col>
                                )
                            }

                        })}

                    </Row>
                </Container>
            </div>
        </div>
    )
}

export default PortFolioDetail